/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lump-sum growth over time`)
};

const es_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crecimiento de un depósito único en el tiempo`)
};

const de_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachstum einer Einmaleinzahlung über die Zeit`)
};

const nl_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groei van eenmalige inleg in de loop van de tijd`)
};

const fr_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Croissance forfaitaire au fil du temps`)
};

const it_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crescita di una somma fissa nel tempo`)
};

const pt_br2_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crescimento de quantia única ao longo do tempo`)
};

const pt_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crescimento de uma quantia única ao longo do tempo`)
};

const ja_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一度の預金の成長`)
};

const zh_cp_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整存款项随时间的增长`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_nav_main_desc", locale)
	if (locale === "en") return en_cp_nav_main_desc(inputs)
	if (locale === "es") return es_cp_nav_main_desc(inputs)
	if (locale === "de") return de_cp_nav_main_desc(inputs)
	if (locale === "nl") return nl_cp_nav_main_desc(inputs)
	if (locale === "fr") return fr_cp_nav_main_desc(inputs)
	if (locale === "it") return it_cp_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_cp_nav_main_desc(inputs)
	if (locale === "pt") return pt_cp_nav_main_desc(inputs)
	if (locale === "ja") return ja_cp_nav_main_desc(inputs)
	return zh_cp_nav_main_desc(inputs)
};